import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header-container">
      {location.pathname === '/Shabdaadhikaaraha' ? (
        <>
          <nav className="navbar">
            <h1 className="header-title">शब्दाधिकारः</h1>
            <h3 className="header-subtitle">अजन्त पुल्लिङ्ग प्रकरणम्</h3>
            <h3 className="header-subtitle-english">Ajanta Pumlinga Prakaranam</h3>
          </nav>
          <div className="navbar-links">
            <Link to="/">Home</Link>
            <a href="#about">About</a>
            <a href="#modules">Modules</a>
            <a href="#contact">Contact</a>
          </div>
        </>
      ) : location.pathname === '/Subantarupaani' || location.pathname === '/Subantarupaani1' ? (
        <>
          <nav className="navbar">
            <h1 className="header-title">सुबन्तरूपाणि</h1>
            <h3 className="header-subtitle">Subantrupani</h3>
          </nav>
          <div className="navbar-links">
           <Link to="/">Home</Link>
            <a href="#about">About</a>
            <a href="#modules">Modules</a>
            <a href="#contact">Contact</a>
          </div>
        </>
      ) : (
        <>
          <nav>
            <div className="header-top-row">
              <div className="header">
                <h1>
                  <a href="http://vedictools.in" target="_blank" rel="noopener noreferrer">
                    VEDIC TOOLS
                  </a>
                </h1>
              </div>
              <button
                className="hamburger-btn"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
              >
                {menuOpen ? '✕' : '☰'}
              </button>
            </div>
            <div className="header">
              <h2>व्याकृत (Sanskrit Analysis Tools)</h2>
            </div>

            {/* Mobile Menu - Dropdown */}
            <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
              <div className="mobile-menu-section">
                <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={handleNavClick}>
                  Home
                </Link>
                <Link to="/sandhi" className={location.pathname === '/sandhi' ? 'active' : ''} onClick={handleNavClick}>
                  Sandhi
                </Link>
                <Link to="/vibhakti" className={location.pathname === '/vibhakti' ? 'active' : ''} onClick={handleNavClick}>
                  Vibhakti
                </Link>
                <Link to="/varnakrama" className={location.pathname === '/varnakrama' ? 'active' : ''} onClick={handleNavClick}>
                  Varnakrama
                </Link>
              </div>
              <div className="mobile-menu-section">
                <Link to="/vikruti" className={location.pathname === '/vikruti' ? 'active' : ''} onClick={handleNavClick}>
                  Vikruti
                </Link>
              </div>
              <div className="mobile-menu-section">
                <Link to="/spardha" className={location.pathname === '/spardha' ? 'active' : ''} onClick={handleNavClick}>
                  स्पर्धा / Demo
                </Link>
                <Link to="/sandhi-vikruti-test" className={location.pathname === '/sandhi-vikruti-test' ? 'active' : ''} onClick={handleNavClick}>
                  Swara-Varna-Sandhi
                </Link>
                <Link to="/padam-process-test" className={location.pathname === '/padam-process-test' ? 'active' : ''} onClick={handleNavClick}>
                  Padam Process Test
                </Link>
                <Link to="/veda-index" className={location.pathname === '/veda-index' ? 'active' : ''} onClick={handleNavClick}>
                  Veda Index
                </Link>
              </div>
              <div className="mobile-menu-section mobile-menu-external">
                <a href="https://vedictools.in/files/pratyaharachart.html" target="_blank" rel="noopener noreferrer">
                  प्रत्याहार सूत्राणि
                </a>
                <a href="https://vedictools.in/files/pratyaharalists.html" target="_blank" rel="noopener noreferrer">
                  प्रत्याहाराः
                </a>
                <a href="https://vedavishtaram.in/sanskrit/s03_varna_vishaya.html" target="_blank" rel="noopener noreferrer">
                  स्थान प्रयत्न
                </a>
              </div>
            </div>
            <div className="tab-container">
              <div className="tab-buttons">
                <a href="https://vedictools.in/files/pratyaharachart.html" className="tab-button" target="_blank" rel="noopener noreferrer">
                  प्रत्याहार सूत्राणि Maaheswara Sutra
                </a>
                <a href="https://vedictools.in/files/pratyaharalists.html" className="tab-button" target="_blank" rel="noopener noreferrer">
                  प्रत्याहाराः Pratyaahaara List
                </a>
                <a href="https://vedavishtaram.in/sanskrit/s03_varna_vishaya.html" className="tab-button" target="_blank" rel="noopener noreferrer">
                  स्थान प्रयत्न विवेकः (Sthaana - Prayatna ...)
                </a>
              </div>
              <div className="nav-buttons-row">
                <Link to="/" className={`test-button ms-1${location.pathname === '/' ? ' active-tab' : ''}`}>
                  Home
                </Link>
                <Link to="/sandhi" className={`test-button ms-1${location.pathname === '/sandhi' ? ' active-tab' : ''}`}>
                  Sandhi
                </Link>
                <Link to="/vibhakti" className={`test-button ms-1${location.pathname === '/vibhakti' ? ' active-tab' : ''}`}>
                  Vibhakti
                </Link>
                <Link to="/varnakrama" className={`test-button ms-1${location.pathname === '/varnakrama' ? ' active-tab' : ''}`}>
                  Varnakrama
                </Link>
                <Link to="/vikruti" className={`test-button ms-1${location.pathname === '/vikruti' ? ' active-tab' : ''}`}>
                  Vikruti
                </Link>
                <Link to="/spardha" className={`test-button ms-1${location.pathname === '/spardha' ? ' active-tab' : ''}`}>
                  स्पर्धा
                </Link>
                <Link to="/sandhi-vikruti-test" className={`test-button ms-1${location.pathname === '/sandhi-vikruti-test' ? ' active-tab' : ''}`}>
                  Swara-Varna-Sandhi
                </Link>
                <Link to="/padam-process-test" className={`test-button ms-1${location.pathname === '/padam-process-test' ? ' active-tab' : ''}`}>
                  Padam Test
                </Link>
                <Link to="/veda-index" className={`test-button ms-1${location.pathname === '/veda-index' ? ' active-tab' : ''}`}>
                  Veda Index
                </Link>
              </div>
            </div>
            <div className="header welcome-section">
              <hr />
              <h4 className="welcome-header" style={{ textAlign: "center" }}>
                Welcome to Sanskrit Exercises in Shiksha & Vyakarana Modules of Vyakruta Project
              </h4>
              <h4 className="welcome-header" style={{ textAlign: "center" }}>
                शिक्षा व्याकरण वर्गे, अभ्यसितुकामाय विविदिषुमण्डलाय स्वागतम्।
              </h4>
            </div>
          </nav>
        </>
      )}
    </header>
  );
};

export default Header;
